export const addUrlParameter = (url, key, value) => {
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.append(key, value);
        return urlObj.toString();
    } catch (e) {
        console.error("Invalid URL provided:", e);
        return url;
    }
};